import BaseService from "../BaseService";
import _ from "lodash";

class ProductCollectionService extends BaseService {
    list = async ({ info, collection_condition_type } = {}) => {
        var data = await this._api.post("/product_collection/list", { info, collection_condition_type });
        return data;
    };

    get = async (id, { include_products = false, info } = {}) => {
        var data = await this._api.get(`/product_collection/get`, {
            params: { id: id, include_products, info },
        });
        return data;
    };

    create = async ({ title, description, url_handle, avatar, banner, collection_condition } = {}) => {
        var data = await this._api.post(`/product_collection/create`, {
            title,
            description,
            url_handle,
            avatar,
            banner,
            collection_condition,
        });
        return data;
    };

    update = async ({ id, title, description, url_handle, avatar, banner, collection_condition } = {}) => {
        var data = await this._api.post(`/product_collection/update`, {
            id,
            title,
            description,
            url_handle,
            avatar,
            banner,
            collection_condition,
        });
        return data;
    };

    delete = async (id) => {
        var data = await this._api.post(`/product_collection/delete`, { id });
        return data;
    };

    products = async ({ id, info } = {}) => {
        var data = await this._api.post(`/product_collection/products`, { id, info });
        return data;
    };


}

export default ProductCollectionService;